import { render, staticRenderFns } from "./Theme4TheHeader.vue?vue&type=template&id=23bf9939&scoped=true&"
import script from "./Theme4TheHeader.vue?vue&type=script&lang=js&"
export * from "./Theme4TheHeader.vue?vue&type=script&lang=js&"
import style0 from "./Theme4TheHeader.vue?vue&type=style&index=0&id=23bf9939&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf9939",
  null
  
)

export default component.exports